import {FC} from 'react'
import {Select, SelectValue} from '@components/commons/select/Select.tsx'
import {SingleValue} from 'react-select'
import {User01Icon} from '@components/ui/icon/Icon.tsx'
import {StyledUserTypeFilterWrapper} from '@components/commons/user-type-filter-select/style.ts'
import {selectUserTypeOption} from '@components/commons/user-type-filter-select/utils.ts'
import {UserType} from '@/types'

interface DateFilterSelectProps {
    onChange: (newValue: SingleValue<{label: string; value: UserType}>) => void
    defaultValue?: SelectValue | []
}
export const UserTypeFilterSelect: FC<DateFilterSelectProps> = ({onChange, defaultValue}) => {
    return (
        <StyledUserTypeFilterWrapper>
            <Select
                icon={<User01Icon />}
                onChange={newValue => onChange(newValue as SingleValue<{label: string; value: UserType}>)}
                defaultValue={defaultValue || selectUserTypeOption[0]}
                options={selectUserTypeOption}
            />
        </StyledUserTypeFilterWrapper>
    )
}
